import { isObject } from '../utils/isObject';

export enum PathNames {
  ACCOUNT = '/account',
  ADMIN_COMPANIES = '/admin/companies',
  ADMIN_COMPANY = '/admin/company',
  ADMIN_FEATURE_FLAGS = '/admin/feature-flags',
  ADMIN_JOB_ADS = '/admin/job-ads',
  ADMIN_JOB_APPLICATIONS = '/admin/job-applications',
  ADMIN_QUIZZES = '/admin/quizzes',
  ADMIN_TALENT_SEARCH = '/admin/talent-search',
  ADMIN_TALENTS = '/admin/talents',
  ADMIN_USERS = '/admin/users',
  AUTH_GITHUB_CALLBACK = '/auth/github/callback',
  AUTH_GOOGLE_CALLBACK = '/auth/google/callback',
  AUTH_MAGIC_VERIFY = '/auth/magic/verify',
  COMPANY_BILLING = '/company/billing',
  COMPANY_CREATE = '/company/create',
  COMPANY_CREATE_SUCCESS = '/company/create/success',
  COMPANY_DASHBOARD = '/company/dashboard',
  COMPANY_INVOICING = '/company/invoicing',
  COMPANY_JOB_AD = '/company/job-ad',
  COMPANY_JOB_AD_CREATE = '/company/job-ad-create',
  COMPANY_JOB_AD_EDIT = '/company/job-ad-edit',
  COMPANY_JOB_ADS = '/company/job-ads',
  COMPANY_JOB_DESCRIPTION = '/company/job-description',
  COMPANY_JOB_DESCRIPTION_CREATE = '/company/job-description-create',
  COMPANY_JOB_DESCRIPTION_EDIT = '/company/job-description-edit',
  COMPANY_JOB_DESCRIPTIONS = '/company/job-descriptions',
  COMPANY_MEMBERS = '/company/members',
  COMPANY_MY_COMPANIES = '/company/my-companies',
  COMPANY_PROFILE = '/company/profile',
  COMPANY_RECEIVED_JOB_APPLICATION = '/company/job-application',
  COMPANY_RECEIVED_JOB_APPLICATIONS = '/company/received-job-applications',
  COMPANY_ROLES = '/company/roles',
  COMPANY_SALES = '/company/sales',
  COMPANY_SENT_INVITATION = '/company/sent-invitation',
  COMPANY_SENT_INVITATIONS = '/company/sent-invitations',
  COMPANY_TALENT_ASSIGNMENT = '/company/talent-assignment',
  COMPANY_TALENT_ASSIGNMENT_CREATE = '/company/talent-assignment-create',
  COMPANY_TALENT_ASSIGNMENT_EDIT = '/company/talent-assignment-edit',
  COMPANY_TALENT_ASSIGNMENTS = '/company/talent-assignments',
  COMPANY_TALENT_INVITE = '/company/talent-invite',
  COMPANY_TALENT_INVITE_FORM = '/company/talent-invite-form',
  COMPANY_TALENT_INVITE_SUCCESS = '/company/talent-invite/success',
  COMPANY_TALENT_ROSTER = '/company/talent-roster',
  COMPANY_TALENT_ROSTER_DETAILS = '/company/talent-roster-details',
  COMPANY_TALENT_SAVED = '/company/talent-saved',
  COMPANY_TRANSACTIONS = '/company/transactions',
  EDIT_USER_ACCOUNT = '/edit-account',
  ERROR = '/error',
  FORGOT_PASSWORD = '/forgot-password',
  HOMEPAGE = '/',
  IMPERSONATE = '/impersonate',
  JOB_APPLY = '/job-apply',
  JOB_APPLY_FORM = '/job-apply-form',
  JOB_APPLY_SUCCESS = '/job-apply/success',
  JOB_SEARCH = '/jobs',
  LOGIN_VIA_SIGNUP = '/login-via-signup',
  RESET_PASSWORD = '/reset-password',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  SIGN_UP_SUCCESS = '/sign-up/success',
  SITE_SETTINGS = '/site-settings',
  TALENT_APPLIED_JOBS = '/talent/applied-jobs',
  TALENT_ASSIGNMENT = '/talent/assignment',
  TALENT_ASSIGNMENT_CREATE = '/talent/assignment-create',
  TALENT_ASSIGNMENT_EDIT = '/talent/assignment-edit',
  TALENT_ASSIGNMENTS = '/talent/assignments',
  TALENT_BILLING = '/talent/billing',
  TALENT_COMPANY = '/talent/company',
  TALENT_DASHBOARD = '/talent/dashboard',
  TALENT_EMPLOYERS = '/talent/employers',
  TALENT_INVITATION = '/talent/invitation',
  TALENT_INVITATIONS = '/talent/invitations',
  TALENT_PROFILE = '/talent/profile',
  TALENT_PROFILE_SUM = '/talent/profile-sum',
  TALENT_PROVIDERS = '/talent/providers',
  TALENT_SAVED_JOBS = '/talent/saved-jobs',
  TALENT_SEARCH = '/company/talent-search',
  TALENT_TRANSACTIONS = '/talent/transactions',
}

export enum ROUTES {
  ACCOUNT = 'ACCOUNT',
  ADMIN_COMPANIES = 'ADMIN_COMPANIES',
  ADMIN_COMPANY = 'ADMIN_COMPANY',
  ADMIN_FEATURE_FLAGS = 'ADMIN_FEATURE_FLAGS',
  ADMIN_JOB_ADS = 'ADMIN_JOB_ADS',
  ADMIN_JOB_APPLICATIONS = 'ADMIN_JOB_APPLICATIONS',
  ADMIN_QUIZZES = 'ADMIN_QUIZZES',
  ADMIN_TALENT_SEARCH = 'ADMIN_TALENT_SEARCH',
  ADMIN_TALENTS = 'ADMIN_TALENTS',
  ADMIN_USERS = 'ADMIN_USERS',
  AUTH_GITHUB_CALLBACK = 'AUTH_GITHUB_CALLBACK',
  AUTH_GOOGLE_CALLBACK = 'AUTH_GOOGLE_CALLBACK',
  AUTH_MAGIC_VERIFY = 'AUTH_MAGIC_VERIFY',
  COMPANY_BILLING = 'COMPANY_BILLING',
  COMPANY_CREATE = 'COMPANY_CREATE',
  COMPANY_CREATE_SUCCESS = 'COMPANY_CREATE_SUCCESS',
  COMPANY_DASHBOARD = 'COMPANY_DASHBOARD',
  COMPANY_INVOICING = 'COMPANY_INVOICING',
  COMPANY_JOB_AD = 'COMPANY_JOB_AD',
  COMPANY_JOB_AD_CREATE = 'COMPANY_JOB_AD_CREATE',
  COMPANY_JOB_AD_EDIT = 'COMPANY_JOB_AD_EDIT',
  COMPANY_JOB_ADS = 'COMPANY_JOB_ADS',
  COMPANY_JOB_DESCRIPTION = 'COMPANY_JOB_DESCRIPTION',
  COMPANY_JOB_DESCRIPTION_CREATE = 'COMPANY_JOB_DESCRIPTION_CREATE',
  COMPANY_JOB_DESCRIPTION_EDIT = 'COMPANY_JOB_DESCRIPTION_EDIT',
  COMPANY_JOB_DESCRIPTIONS = 'COMPANY_JOB_DESCRIPTIONS',
  COMPANY_MEMBERS = 'COMPANY_MEMBERS',
  COMPANY_MY_COMPANIES = 'COMPANY_MY_COMPANIES',
  COMPANY_PROFILE = 'COMPANY_PROFILE',
  COMPANY_RECEIVED_JOB_APPLICATION = 'COMPANY_RECEIVED_JOB_APPLICATION',
  COMPANY_RECEIVED_JOB_APPLICATIONS = 'COMPANY_RECEIVED_JOB_APPLICATIONS',
  COMPANY_ROLES = 'COMPANY_ROLES',
  COMPANY_SALES = 'COMPANY_SALES',
  COMPANY_SENT_INVITATION = 'COMPANY_SENT_INVITATION',
  COMPANY_SENT_INVITATIONS = 'COMPANY_SENT_INVITATIONS',
  COMPANY_TALENT_ASSIGNMENT = 'COMPANY_TALENT_ASSIGNMENT',
  COMPANY_TALENT_ASSIGNMENT_CREATE = 'COMPANY_TALENT_ASSIGNMENT_CREATE',
  COMPANY_TALENT_ASSIGNMENT_EDIT = 'COMPANY_TALENT_ASSIGNMENT_EDIT',
  COMPANY_TALENT_ASSIGNMENTS = 'COMPANY_TALENT_ASSIGNMENTS',
  COMPANY_TALENT_INVITE = 'COMPANY_TALENT_INVITE',
  COMPANY_TALENT_INVITE_FORM = 'COMPANY_TALENT_INVITE_FORM',
  COMPANY_TALENT_INVITE_SUCCESS = 'COMPANY_TALENT_INVITE_SUCCESS',
  COMPANY_TALENT_ROSTER = 'COMPANY_TALENT_ROSTER',
  COMPANY_TALENT_ROSTER_DETAILS = 'COMPANY_TALENT_ROSTER_DETAILS',
  COMPANY_TALENT_SAVED = 'COMPANY_TALENT_SAVED',
  COMPANY_TRANSACTIONS = 'COMPANY_TRANSACTIONS',
  EDIT_USER_ACCOUNT = 'EDIT_USER_ACCOUNT',
  ERROR = 'ERROR',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  HOMEPAGE = 'HOMEPAGE',
  IMPERSONATE = 'IMPERSONATE',
  JOB_APPLY = 'JOB_APPLY',
  JOB_APPLY_FORM = 'JOB_APPLY_FORM',
  JOB_APPLY_SUCCESS = 'JOB_APPLY_SUCCESS',
  JOB_SEARCH = 'JOB_SEARCH',
  LOGIN_VIA_SIGNUP = 'LOGIN_VIA_SIGNUP',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
  SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS',
  SITE_SETTINGS = 'SITE_SETTINGS',
  TALENT_APPLIED_JOBS = 'TALENT_APPLIED_JOBS',
  TALENT_ASSIGNMENT = 'TALENT_ASSIGNMENT',
  TALENT_ASSIGNMENT_CREATE = 'TALENT_ASSIGNMENT_CREATE',
  TALENT_ASSIGNMENT_EDIT = 'TALENT_ASSIGNMENT_EDIT',
  TALENT_ASSIGNMENTS = 'TALENT_ASSIGNMENTS',
  TALENT_BILLING = 'TALENT_BILLING',
  TALENT_COMPANY = 'TALENT_COMPANY',
  TALENT_DASHBOARD = 'TALENT_DASHBOARD',
  TALENT_EMPLOYERS = 'TALENT_EMPLOYERS',
  TALENT_INVITATION = 'TALENT_INVITATION',
  TALENT_INVITATIONS = 'TALENT_INVITATIONS',
  TALENT_PROFILE = 'TALENT_PROFILE',
  TALENT_PROFILE_SUM = 'TALENT_PROFILE_SUM',
  TALENT_PROVIDERS = 'TALENT_PROVIDERS',
  TALENT_SAVED_JOBS = 'TALENT_SAVED_JOBS',
  TALENT_SEARCH = 'TALENT_SEARCH',
  TALENT_TRANSACTIONS = 'TALENT_TRANSACTIONS',
}

export const getRoutingPath = (pathKey: keyof typeof PathNames): string => {
  return PathNames[pathKey] || PathNames[ROUTES.HOMEPAGE];
};

/**
 * Generates a routing path with optional query parameters.
 *
 * @param {keyof typeof PathNames} pathKey - The key to lookup the base path from the `PathNames` object.
 * @param {...(string | number | Record<string, any>)} args - The path segments and optional query parameters.
 *   - Path segments are added to the path.
 *   - If the last argument is an object, it is treated as query parameters.
 * @returns {string} The constructed URL path with optional query string.
 */
export const generateRoutingPath = (
  pathKey: keyof typeof PathNames,
  ...args: (number | Record<string, any> | string)[]
): string => {
  const path = PathNames[pathKey] || PathNames[ROUTES.HOMEPAGE];
  const lastArg = args[args.length - 1];
  const queryObject = isObject(lastArg) ? (args.pop() as Record<string, any>) : {};

  const filteredQueryObject = Object.fromEntries(
    Object.entries(queryObject).filter(([, value]) => !!value),
  );

  const tail = args.length ? '/' + args.join('/') : '';
  const queryString = Object.keys(filteredQueryObject).length
    ? '?' + new URLSearchParams(filteredQueryObject).toString()
    : '';

  return path + tail + queryString;
};
